export enum RepeatType {
  DAYS = 'days',
  WEEKS = 'weeks',
  MONTHS = 'months',
}

export interface IListItem {
  name: string;
  id: string;
}

export interface IUserDetail {
  id: string;
  email: string;
  name?: string;
  secondaryEmail?: string;
}

export interface SessionTime {
  date: Date;
  startTime: string;
  endTime: string;
  hostedBy: string[];
}
